/**
 * Which names a «Месяц» cell shows (D-76): up to 3 in time order; with more,
 * 2 names and «+N». N counts from appointment_count, because the server sends
 * at most MONTH_CHIPS (4) chips (app/api/v1/calendar.py).
 */
import type { MonthDay } from '../types';

export function monthNames(chips: MonthDay['chips'], count: number): { shown: MonthDay['chips']; more: number } {
  return count > 3 ? { shown: chips.slice(0, 2), more: count - 2 } : { shown: chips.slice(0, 3), more: 0 };
}
